export default class AssetsLoader {
  constructor(options) {
    const {
      sounds,
      images,
    } = options;

    this.sounds = sounds;
    this.images = images;
    this.imgSources = {};
    this.soundsSources = {};
  }

  getImage(imgName) {
    return this.imgSources[imgName];
  }

  getSound(audioName) {
    return this.soundsSources[audioName];
  }

  load() {
    const {
      sounds,
      images,
    } = this;

    return new Promise((resolve) => {
      const audioPromises = Object.keys(sounds).map(soundName => {
        const filename = sounds[soundName];
        const soundUrl = `assets/Sounds/${filename}`;
        const audioPromise = this.loadAudio(soundUrl);
        audioPromise.then((buffer) => {
          this.sounds[soundName] = buffer;

          const audioEl = document.createElement( 'audio' );
          const sourceEl = document.createElement( 'source' );
          sourceEl.src = soundUrl;
          audioEl.appendChild(sourceEl);
          this.soundsSources[soundName] = audioEl;
        });
        return audioPromise;
      });

      const imagePromises = Object.keys(images).map(imgName => {
        const filename = images[imgName];
        const imgUrl = `assets/images/${filename}`;
        const imagePromise = this.loadImage(imgUrl);
        imagePromise.then((img) => {
          this.imgSources[imgName] = img;
        });
        return imagePromise;
      });
      Promise.all(
        audioPromises.concat(imagePromises)
      ).then(() => {
        resolve();
      });
    });
  }

  loadImage(imgUrl) {
    return new Promise((resolve) => {
      var loader = new THREE.ImageLoader();

// load a image resource
      loader.load(imgUrl, (image) => {
        resolve(image);
      },
        // Function called when download progresses
        function ( xhr ) {
          // console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
        },
        // Function called when download errors
        function ( xhr ) {
          // console.log( 'An error happened' );
        }
      );
    });
  }

  loadAudio(url) {
    return new Promise((resolve) => {
      const audioLoader = new THREE.AudioLoader();
      audioLoader.load(url, function( buffer ) {
        resolve(buffer);
      });
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/AssetsLoader.js
 **/